"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrOpeningStatusWrapper = exports.FdrScheduleWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.FdrScheduleWrapper = styled_components_1.default.div(({ theme }) => theme.helpOverlay.schedule, ({ opened, theme: { colors } }) => ({
    '> p': {
        color: opened ? `green` : colors.primary,
    },
}));
exports.FdrOpeningStatusWrapper = styled_components_1.default.p(({ opened, showStatusIcon, theme: { colors, space } }) => ({
    position: 'relative',
    '&:before': showStatusIcon
        ? {
            content: "''",
            position: 'absolute',
            top: space[2],
            left: '-24px',
            width: '12px',
            height: '12px',
            backgroundColor: opened ? colors.success : colors.error,
            borderRadius: '50%',
        }
        : {},
}));
//# sourceMappingURL=fdr-schedule.styles.js.map